import { render, staticRenderFns } from "./account-message-modal.vue?vue&type=template&id=55948a8d&scoped=true&"
import script from "./account-message-modal.vue?vue&type=script&lang=js&"
export * from "./account-message-modal.vue?vue&type=script&lang=js&"
import style0 from "./account-message-modal.vue?vue&type=style&index=0&id=55948a8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55948a8d",
  null
  
)

export default component.exports